import React from 'react';
import {WingBlank, ImageLayer, Layer, Cards} from '../../components';
import App from '../App/App';
import CaseBanner from './CaseBanner';
import CaseMenu from './CaseMenu';
import CaseTitleMobile from './CaseTitleMobile';
import ServiceBreadcrumb from '../Service/ServiceBreadcrumb';
import Introduce from './Introduce';
import ValueCard from './ValueCard';
import {banner, content, menu, lg, md, lm} from './config';
import './Case.less';

function findPath(path) {
  const item = menu.find(item => item.key === path);
  return item ? ['客户案例', item.title] : null;
}

function Content({nav, path, menu, data}) {
  return (
    <WingBlank data-role='Content'>
      <CaseMenu title='客户案例' menu={menu} nav={nav} />
      <div>
        <ServiceBreadcrumb path={path}/>
        <div>
          <CaseTitleMobile menu={menu}>{path[1]}</CaseTitleMobile>
          <Layer title='项目简介' size='small' grey>
            <Introduce nav={nav} data={data.introduce}/>
          </Layer>
          <ImageLayer title='项目方案' src={data.method} size='small'/>
          <Cards title='价值呈现' data={data.value} size='small' lg={lg[nav]} md={md[nav] || 1} lm={lm[nav] || 1} grey>
            <ValueCard nav={nav}/>
          </Cards>
        </div>
      </div>
    </WingBlank>
  );
}

const TITLE = {
  composite: '客户案例-综合物流案例',
  smart: '客户案例-智慧运输案例',
  warehouse: '客户案例-仓配案例',
  optimize: '客户案例-零担运输路径优化案例',
  bulk: '客户案例-大宗物流案例',
  park: '客户案例-园区物流案例',
  online: '客户案例-综合电商平台案例',
};

function Case({params: {nav}}) {
  if (!global.isServer) {
    document.title = TITLE[nav];
  }
  const path = findPath(nav);
  return (
    <App className='Case' key={nav}>
      <CaseBanner data={banner}/>
      {path ? <Content {...{nav, path, menu, data: content[nav]}} /> : null}
    </App>
  );
}

export default Case;



// WEBPACK FOOTER //
// ./src/routes/Case/Case.js